<template>
  <slot
    :click="onClick"
    :disabled="!planPermissionValidate"
    :oldPlan="isOldPlan()"
    :planId="getPlanInfo().planId"></slot>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { usePlanPermission } from '../../composable/usePlanPermission';
type TProps = {
  permissionType: string;
  click: Function;
};
const { getPermissionForTypeInfo, isOldPlan, getPlanInfo } = usePlanPermission();
const { permissionType, click } = defineProps<TProps>();
const planPermissionValidate = computed(() => {
  return getPermissionForTypeInfo(permissionType);
});
const onClick = () => {
  click(!planPermissionValidate.value);
};
</script>

<style lang="scss" scoped></style>
